import { useCallback, useEffect, useRef, useState } from 'react';

import { getRoles } from '../../roles/api/roles.api';
import type { RoleApiResponse } from '../../roles/api/roles.api';

export function useTenantRoles(tenantId: number | undefined) {
  const [roles, setRoles] = useState<RoleApiResponse[]>([]);
  const [loading, setLoading] = useState(Boolean(tenantId));
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);
  const requestGenerationRef = useRef(0);

  const loadRoles = useCallback(() => {
    const generation = ++requestGenerationRef.current;
    const isCurrentRequest = () =>
      mountedRef.current && requestGenerationRef.current === generation;

    if (tenantId === undefined) {
      setRoles([]);
      setLoading(false);
      setError(null);
      return Promise.resolve();
    }

    setLoading(true);
    setError(null);

    return getRoles(tenantId)
      .then((data) => {
        if (isCurrentRequest()) setRoles(data);
      })
      .catch(() => {
        if (isCurrentRequest()) setError('خطا در دریافت نقش‌های این تننت');
      })
      .finally(() => {
        if (isCurrentRequest()) setLoading(false);
      });
  }, [tenantId]);

  useEffect(() => {
    mountedRef.current = true;
    void loadRoles();
    return () => {
      mountedRef.current = false;
    };
  }, [loadRoles]);

  return { roles, loading, error, refetch: loadRoles };
}
